/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Circle,
    Close,
    DoneAll,
    NotificationsActive,
    TagFaces,
  } from "@mui/icons-material";
  import {
    Badge,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Fab,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Popover,
    Tooltip,
  } from "@mui/material";
  import styles from "../../Styles/mainHeader.module.css";
  import { Fragment, useEffect, useState } from "react";
  import moment from "moment";
  import { getData } from "../../Services/getData";
  import { urlEnum } from "../../Utils/UrlEnum";
  import { Vocabulary } from "../../Utils/Vocabulary";
  import { updateData } from "../../Services/updateData";
  import socket from "../../Utils/Socket";
  export default function Notifications() {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [notificationCount, setNotificationCount] = useState<number>(0);
    const [notifications, setNotifications] = useState<any[]>([]);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    
    const handleProductsUpdate = (data: any) => {
      setNotifications(data.notifications);
      setNotificationCount(data.count);
    };

    const getNotifications = () => {
      socket.emit("getNotifications", { userId: localStorage.getItem("userId") });
      socket.on("notifications", handleProductsUpdate);
    }

    useEffect(() => {
      getNotifications();
      socket.on("persistNotifications",getNotifications);
    }, []);
  
    /**
     *
     */
    const getNotificationsForUser = () => {
      const userId = localStorage.getItem("userId");
      getData(`${urlEnum.notifications}/${userId}`).then((res) => {
        if (res) {
          setNotifications(res.data.result);
          setNotificationCount(res.data.count);
        }
      });
    };
  
    /**
     *
     * @param event
     */
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    /**
     *
     */
    const handleClose = () => {
      const unreadNotifications = notifications
        .filter((notification) => !!notification.seen === false)
        .map((notification) => notification._id);
      if (unreadNotifications.length > 0) {
        updateData(`${urlEnum.notifications}/markAsRead`, {
          notificationsIds: unreadNotifications,
        }).then((res: any) => {
          if (res) {
            getNotificationsForUser();
          }
        });
      }
      setAnchorEl(null);
    };
  
    return (
      <>
        <Fab size="small" className={styles.fab} onClick={handleClick}>
          <Badge
            badgeContent={notificationCount}
            max={100}
            classes={{ badge: styles.badge }}
          >
            <NotificationsActive />
          </Badge>
        </Fab>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Card>
            <CardHeader
              subheader={Vocabulary.notifications}
              action={
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              }
            />
            <CardContent sx={{ padding: 0 }}>
              <List>
                {notifications && notifications.length > 0 ? (
                  notifications.map((notification: any) => {
                    return (
                      <Fragment key={notification.id}>
                        <Tooltip title={notification.message}>
                          <ListItem
                            className={`${
                              notification.seen
                                ? styles.notificationRead
                                : styles.notificationNotRead
                            }`}
                          >
                            <ListItemAvatar
                              className={`${
                                notification.seen
                                  ? styles.messageRead
                                  : styles.messageNotRead
                              }`}
                            >
                              {notification.seen ? <DoneAll /> : <Circle />}
                            </ListItemAvatar>
                            <ListItemText
                              className={`${
                                notification.seen
                                  ? styles.messageRead
                                  : styles.messageNotRead
                              }`}
                              primary={`${notification.message?.substring(
                                0,
                                50
                              )}...`}
                              secondary={moment(notification.createdAt).format(
                                "DD-MM-YYYY HH:mm"
                              )}
                            />
                          </ListItem>
                        </Tooltip>
                        <Divider />
                      </Fragment>
                    );
                  })
                ) : (
                  <ListItem>
                    <ListItemText>{Vocabulary.noNotifications} </ListItemText>
                    <ListItemAvatar>
                      <TagFaces />
                    </ListItemAvatar>
                  </ListItem>
                )}
              </List>
            </CardContent>
          </Card>
        </Popover>
      </>
    );
  }
  